var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorizar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 12H13.6667V10.9333H9.4V12ZM9.4 9.06667H13.6667V8H9.4V9.06667ZM9.4 6.13333H13.6667V5.06667H9.4V6.13333ZM3 8.53333C3 6.624 4.55733 5.06667 6.46667 5.06667H6.73333V4L8.33333 5.6L6.73333 7.2V6.13333H6.46667C5.13333 6.13333 4.06667 7.2 4.06667 8.53333C4.06667 9.86667 5.13333 10.9333 6.46667 10.9333H8.33333V12H6.46667C4.55733 12 3 10.4427 3 8.53333Z",
    fill: "#24A95D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 3.75,
    stroke: "#24A95D",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorizar);
export default __webpack_public_path__ + "static/media/priorizar.16f236562c6237c33ca8ca00fa55b8b2.svg";
export { ForwardRef as ReactComponent };